import { Keyword, List, String, Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
const { either, map, separatedList } = Parser;
const parse = List.parseCommaSeparated(either(Keyword.parse("serif", "sans-serif", "cursive", "fantasy", "monospace"), either(String.parse, map(separatedList(Token.parseIdent(), Token.parseWhitespace), (idents) => String.of(idents.map((ident) => ident.value).join(" "))))));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-family}
 * @internal
 */
export default Longhand.of(List.of([Keyword.of("serif")], ", "), parse, (fontFamily) => fontFamily, {
    inherits: true,
});
//# sourceMappingURL=font-family.js.map